/**
 * The role a user can have.
 */
export enum UserRole {
  Admin = 'admin',
  Breeder = 'breeder',
  ServiceProvider = 'service_provider',
  CompanyUser = 'company_user',
  User = 'user',
  CSVSubmitter = 'csv_submitter',
}
